/**
 * Lorven scroll reveal. Marks sections, cards and tiles with data-lv, then fades them in as
 * they enter the viewport. Siblings get a stagger index. Skipped in the theme editor and when
 * the visitor prefers reduced motion.
 */
(() => {
  if (window.Shopify?.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const SELECTOR = [
    'main .shopify-section',
    'main product-card',
    'main .lorven-tile',
    'footer .shopify-section',
  ].join(',');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('lv-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  /** @param {ParentNode} root */
  const register = (root) => {
    const targets = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (const el of targets) {
      if (el.hasAttribute('data-lv')) continue;
      // The first section is the hero, which should never wait on scroll.
      if (el.matches('main .shopify-section:first-child')) continue;
      const siblings = el.parentElement ? [...el.parentElement.children] : [el];
      el.style.setProperty('--lv-i', String(Math.min(siblings.indexOf(el), 8)));
      el.setAttribute('data-lv', '');
      observer.observe(el);
    }
  };

  const start = () => {
    register(document);
    const main = document.querySelector('main');
    if (!main) return;
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node instanceof Element) {
            if (node.matches(SELECTOR)) register(node.parentElement ?? document);
            register(node);
          }
        }
      }
    }).observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
